const REMOTE_API_BASE_URL = 'https://qa.lumera.ru';

const resolveLocalApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol || 'http:';
    const host = window.location.hostname || 'localhost';
    return `${protocol}//${host}:8080`;
  }
  return 'http://localhost:8080';
};

const resolveApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const port = window.location.port;
    if ((host === 'localhost' || host === '127.0.0.1') && (port === '3000' || port === '3002')) {
      return '';
    }
    if (host === 'localhost' || host === '127.0.0.1') {
      return resolveLocalApiBaseUrl();
    }
  }

  return process.env.NODE_ENV === 'production'
    ? REMOTE_API_BASE_URL
    : resolveLocalApiBaseUrl();
};

const config = {
  API_BASE_URL: resolveApiBaseUrl(),
};

export default config;
